import { Search, Filter, ChevronDown } from 'lucide-react';

const TransportFilters = ({ 
  searchTerm, 
  setSearchTerm, 
  selectedFilter, 
  setSelectedFilter,
  showMobileFilters,
  setShowMobileFilters 
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-4 border border-gray-100">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* Search Input */}
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
              type="text"
              placeholder="Caută după client, ID, rută, șofer..."
              className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        
        {/* Desktop Filter */}
        <div className="hidden sm:block">
          <select
            className="px-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white min-w-[160px]"
            value={selectedFilter}
            onChange={(e) => setSelectedFilter(e.target.value)}
          >
            <option value="all">Toate statusurile</option>
            <option value="in_asteptare">În așteptare</option>
            <option value="pe_drum">În tranzit</option>
            <option value="in_incarcare">În încărcare</option>
            <option value="livrat">Finalizate</option>
            <option value="anulat">Anulate</option>
          </select>
        </div>

        {/* Mobile Filter Button */}
        <button
          className="sm:hidden flex items-center px-4 py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50"
          onClick={() => setShowMobileFilters(!showMobileFilters)}
        >
          <Filter className="w-4 h-4 mr-2" />
          Filtrare
          <ChevronDown className="w-4 h-4 ml-2" />
        </button>
      </div>

      {/* Mobile Filters Dropdown */}
      {showMobileFilters && (
        <div className="sm:hidden mt-4 pt-4 border-t border-gray-200">
          <select
            className="w-full px-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
            value={selectedFilter}
            onChange={(e) => {
              setSelectedFilter(e.target.value);
              setShowMobileFilters(false);
            }}
          >
            <option value="all">Toate statusurile</option>
            <option value="in_asteptare">În așteptare</option>
            <option value="pe_drum">În tranzit</option>
            <option value="in_incarcare">În încărcare</option>
            <option value="livrat">Finalizate</option>
            <option value="anulat">Anulate</option>
          </select>
        </div>
      )}
    </div>
  );
};

export default TransportFilters;